































import { computed, defineComponent, PropType, toRef } from 'vue';
import { AttachmentModel } from '../models/attachment.model';
import { parentTypes } from '../enums/parentTypes';
import AttachmentList from './AttachmentList.vue';
import MediaThumbnail from './MediaThumbnail.vue';
import MediaDetail from '../../src/components/gallery/MediaDetail.vue';
import { useUserProfileStore } from '../stores';
import { useMediaAttachmentsGrid } from '../composables/useMediaAttachmentsGrid';
import { useMediaGallery } from '../composables/useMediaGallery';

export default defineComponent({
  name: 'MediaAttachmentsPreview',
  components: { AttachmentList, MediaDetail, MediaThumbnail },
  props: {
    attachments: { type: Array as PropType<AttachmentModel[]>, default: () => [] },
    parent: { type: String as PropType<parentTypes>, default: parentTypes.GALLERY },
    attachmentListShowMedia: { type: Boolean, default: false },
    attachmentListShort: { type: Boolean, default: false },
    thumbnailCount: { type: Number, default: 4 },
  },
  emits: ['openDocumentDrawer', 'mediaDelete'],
  setup(props, { emit }) {
    const attachmentsRef = toRef(props, 'attachments');
    const profileId = computed<number | null>(() => {
      const profile = useUserProfileStore()?.institutionProfile;
      return (profile?.profileId as number | undefined) ?? null;
    });

    const { visibleThumbnailMedia, mediaList, gridLayoutClass, getOverlayText, removeMedia } = useMediaAttachmentsGrid(
      attachmentsRef,
      profileId,
      { thumbnailCount: props.thumbnailCount }
    );

    const { isVisibleMediaGallery, selectedMediaId, openMediaGallery, closeMediaGallery } = useMediaGallery();

    const onOpenDocumentDrawer = (data: unknown): void => {
      emit('openDocumentDrawer', data);
    };

    const onMediaDelete = (mediaId: number): void => {
      removeMedia(mediaId);
      emit('mediaDelete', mediaId);
    };

    return {
      visibleThumbnailMedia,
      mediaList,
      gridLayoutClass,
      getOverlayText,
      isVisibleMediaGallery,
      selectedMediaId,
      openMediaGallery,
      closeMediaGallery,
      onOpenDocumentDrawer,
      onMediaDelete,
    };
  },
});
